import React from 'react';
import { Link } from 'react-router-dom';
import './Card.css';

const Card = (props) => (
  <div className="col-md-3 fade-in course-container">
    <div className="course-single flacso-azul">
      <Link to={{ pathname: `/detalle-curso/${props.type}/${props.mainState.id}`, state: { props } }}>
        <figure>
          <img src={props.mainState.fields.Imagen[0].thumbnails.large.url} alt="" className="img-responsive img-format"/>
        </figure>
        <div className="course-content flacso-azul content-custom">
          <h3 className="h3-format">{props.mainState.fields.Curso}</h3>
          <hr/>
          <h4 className="h4-format">Fecha: {props.mainState.fields.Fecha}</h4>
          <hr/>
          <ul className="list-unstyled list-format">
          <li style={{display:'flex',alignItems:'center', fontSize:'11px'}} className="mobile">
            <div style={{textAlign: 'left'}}>
              Equipo:<br/> {props.mainState.fields.Equipo ? <div dangerouslySetInnerHTML={{ __html: props.mainState.fields.Equipo }}></div> : "A confirmar"}
            </div>
          </li>
          </ul>
        </div>
      </Link>
    </div>
  </div>
);

export default Card;
